import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "Progress"
}
const _hoisted_2 = { class: "card mb-3" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-light\"><div class=\"row align-items-center\"><div class=\"col\"><h4>Assignments</h4></div></div><div class=\"row flex-between-center\"><div class=\"align-items-center aling-middle fs--1\"> Listed assignments are already part of the Classgroup. <span class=\"fas fa-info-circle icon-info\"></span></div></div></div>", 1)
const _hoisted_4 = ["data-list"]
const _hoisted_5 = { class: "table-responsive scrollbar" }
const _hoisted_6 = { class: "table table-sm fs--1 mb-0 table-hover" }
const _hoisted_7 = { class: "bg-white text-900" }
const _hoisted_8 = { class: "text-props" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "col-sm-4"
}, "Excercise", -1)
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "list" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-light py-2\"><div class=\"d-flex justify-content-center\"><button class=\"btn btn-sm btn-falcon-default me-1\" type=\"button\" title=\"Previous\" data-list-pagination=\"prev\"><span class=\"fas fa-chevron-left\"></span></button><ul class=\"pagination mb-0\"></ul><button class=\"btn btn-sm btn-falcon-default ms-1\" type=\"button\" title=\"Next\" data-list-pagination=\"next\"><span class=\"fas fa-chevron-right\"></span></button></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_FormatDate = _resolveComponent("FormatDate")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.classgroupAssignments.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "card-body px-0 py-0",
                id: "assignments-data-table",
                "data-list": JSON.stringify(_ctx.dataListOptions)
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", _hoisted_6, [
                    _createElementVNode("thead", _hoisted_7, [
                      _createElementVNode("tr", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("th", {
                          scope: "col",
                          class: "pr-1 align-middle white-space-nowrap",
                          "data-sort": "availableFrom",
                          textContent: _toDisplayString('Available from')
                        }, null, 8, _hoisted_10),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "pr-1 align-middle white-space-nowrap ps-3",
                          "data-sort": "deadline",
                          textContent: _toDisplayString('Deadline')
                        }, null, 8, _hoisted_11),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "pr-1 align-middle white-space-nowrap",
                          "data-sort": "notesForMe",
                          textContent: _toDisplayString('My Notes')
                        }, null, 8, _hoisted_12),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "pr-1 align-middle white-space-nowrap",
                          "data-sort": "notesForStudents",
                          textContent: _toDisplayString('Notes for students')
                        }, null, 8, _hoisted_13)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classgroupAssignments, (assignment) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: assignment.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatExerciseTitle(assignment.exerciseId)), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_FormatDate, {
                              dateToFormat: assignment.availableFrom
                            }, null, 8, ["dateToFormat"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_FormatDate, {
                              dateToFormat: assignment.deadline
                            }, null, 8, ["dateToFormat"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(assignment.notesForMe), 1),
                          _createElementVNode("td", null, _toDisplayString(assignment.notesForStudents), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _hoisted_15
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ]))
}